<template>
    <div class="my_wayBill">
        <order-filter
                :title="'运单筛选'"
                :type="'tracking'"
                :visible.sync="filterShow"
                @confirm="confirmFilter"
                :is-need-refresh="refresh"
                @refresh="refresh = false">
        </order-filter>

        <div class="my_wayBill_box" ref="box">
            <van-list
                    style="height: 100%;overflow: scroll;-webkit-overflow-scrolling: touch;padding: 0"
                    :loading="loading"
                    :finished="finished[this.index]"
                    @load="onLoad">
                <div class="my_wayBill-top">
                    <div v-show="!filterShow">
                        <div class="my_wayBill-top-search" @click="filterShow = true">
                            <img src="../../assets/search.png"/>
                            <span>筛选条件</span>
                            <img src="../../assets/scan.png"/>
                        </div>
                    </div>
                </div>
                <van-tabs
                        class="my_wayBill-tabs"
                        v-show="!filterShow"
                        v-model="index"
                        @click="handleClick"
                        animated
                        swipeable
                        sticky
                        :offsetTop="'1.15rem'">
                    <van-tab title="我寄的">
                        <van-pull-refresh
                                v-model="loading"
                                style="padding-bottom: 1.7rem;box-sizing: border-box"
                                @refresh="onRefresh">
                            <van-list
                                    :loading="loading"
                                    :finished="finished[this.index]">
                                <div class="no-list" v-if="sendList.length === 0">暂无数据</div>
                                <order-item
                                        :flag="1"
                                        :type="'tracking'"
                                        :to="'/order/waybilldetail?t=true&trackingId=' + item.id+'&flag=1'"
                                        v-for="item in sendList"
                                        :key="item.id"
                                        :item="item"/>
                            </van-list>
                        </van-pull-refresh>
                    </van-tab>
                    <van-tab title="我收的">
                        <van-pull-refresh
                                v-model="loading"
                                style="overflow:unset; padding-bottom: 1.7rem;"
                                @refresh="onRefresh">
                            <van-list
                                    :loading="loading"
                                    :finished="finished[this.index]">
                                <order-item
                                        :flag="2"
                                        :type="'tracking'"
                                        :to="'/order/waybilldetail?t=true&trackingId=' + item.id+'&flag=2'"
                                        v-for="item in acceptList"
                                        @handleConfirmGoods="handleConfirmGoods"
                                        :key="item.id"
                                        :item="item"/>
                            </van-list>
                        </van-pull-refresh>
                    </van-tab>

                </van-tabs>
            </van-list>


        </div>

        <div v-show="!filterShow" class="total">
            <!--            <div class="total-text">合计</div>-->
            <div class="total-row">
                <van-row>
                    <van-col span="12"
                    >票数：{{ total[this.index].votesTotal }}票
                    </van-col
                    >
                    <van-col span="12"
                    >件数：{{ total[this.index].goodsNumberTotal }}件
                    </van-col
                    >
                </van-row>
                <van-row style="padding-top: 0.1rem;">
                    <van-col>{{this.index==1?'到付运费':'现付运费'}}：{{ total[this.index].freightTotal }}元</van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MyWayBill",
        components: {
            OrderFilter: () => import('./components/OrderFilter'),
            OrderItem: () => import('./components/OrderItem')
        },
        data() {
            return {
                isCut: [false, false],
                //是否切换过
                refresh: false,
                filterShow: false,
                index: 1,
                flag: 1,
                loading: false,
                // 加载是否已完成
                finished: [false, false],
                // 页码
                pageNum: [1, 1],
                // 是否有下一页
                hasNextPage: [true, true],
                // 发列表
                sendList: [],
                // 收列表
                acceptList: [],
                // 总计数
                total: [
                    {
                        votesTotal: 0
                    },
                    {
                        votesTotal: 0
                    }
                ],
                filterKey: {
                    logisticsCompanyId: this.$logisticsCompanyId,
                    consigneeCityCode: "",
                    consigneeName: "",
                    consigneePhone: "",
                    startTime: "",
                    endTime: "",
                    pullPackWorkerName: "",
                    concatPhone: "",
                    orderNumber: "",
                    trackingNumber: "",
                    status: ""
                }
            }
        },
        watch: {
            filterShow(val) {
                if (val) {
                    this.$store.commit('hanldheaderShow', !val)
                } else {
                    this.$store.commit('hanldheaderShow', !val)
                }
            },
            index(val) {
                if (!this.isCut[val]) {
                    this.isCut[val] = true
                    this.getList(true)
                }
            }
        },
        created() {
            this.index = sessionStorage.getItem('myTrackingIndex') * 1 || 0
            // let params = {
            //     page: {
            //         pageNum: 1,
            //         pageSize: 10
            //     },
            //     params: {
            //         flag: 1,
            //         logisticsCompanyId: this.$logisticsCompanyId
            //     }
            // };
            // this.$axios.post("merchant/my_waybill", params).then(res => {
            //     if (res.data.code === 200) {
            //         let data = res.data.data;
            //         this.total[0] = data.params;
            //         this.sendList = data.list;
            //         this.loading = false;
            //         // this.hasNextPage[0] = data.hasNextPage;
            //         // this.finished[0] = !data.hasNextPage;
            //         // this.pageNum[0]++;
            //         // params.params.flag = 2;
            //     }
            // });
        },
        methods: {
            handleClick(index) {
                sessionStorage.setItem("myTrackingIndex", index)
                if (index == 1) {
                    document.getElementsByClassName('van-tab__pane')[0].style.height = '0'
                    document.getElementsByClassName('van-tab__pane')[1].style.height = 'auto'
                } else {
                    document.getElementsByClassName('van-tab__pane')[1].style.height = '0'
                    document.getElementsByClassName('van-tab__pane')[0].style.height = 'auto'
                }
            },

            //获取订单列表
            getList(empty) {
                let params, url;
                if (this.index == 0) {
                    this.filterKey.flag = 1;
                    params = {
                        page: {
                            pageNum: this.pageNum[this.index],
                            pageSize: 10
                        },
                        params: this.filterKey
                    };
                    url = "merchant/my_waybill";
                } else {
                    this.filterKey.flag = 2;
                    params = {
                        page: {
                            pageNum: this.pageNum[this.index],
                            pageSize: 10
                        },
                        params: this.filterKey
                    };
                    url = "merchant/my_waybill";
                }
                this.loading = true;
                this.$axios.post(url, params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        if (empty) {
                            if (this.index == 0) {
                                this.sendList = data.list;
                            } else {
                                this.acceptList = data.list;
                            }
                        } else {
                            if (this.index == 0) {
                                this.sendList = this.sendList.concat(data.list);
                            } else {
                                this.acceptList = this.acceptList.concat(data.list);
                            }
                        }
                        this.total[this.index] = data.params;
                        this.pageNum[this.index]++;
                        this.hasNextPage[this.index] = data.hasNextPage;
                        this.loading = false;
                        this.finished[this.index] = !data.hasNextPage;
                        // this.finished[this.index] = true;
                    }
                });
            },
            // 加载列表
            onLoad() {
                if (this.loading == false) this.getList(false);
            },
            // 下拉刷新
            onRefresh() {
                this.pageNum[this.index] = 1;
                this.loading = true;
                Object.keys(this.filterKey).forEach(key => {
                    this.$set(this.filterKey, key, "");
                });
                this.filterKey.logisticsCompanyId = this.$logisticsCompanyId
                this.getList(true);
                this.refresh = true;
            },
            // 跳转至物流查询页
            logisticsSearch(orderNumber) {
                this.$router.push("/search/logistics/" + orderNumber);
            },
            // 确认筛选
            confirmFilter(filterKey) {
                this.pageNum[this.index] = 1;
                this.filterKey = JSON.parse(JSON.stringify(filterKey));
                this.getList(true);
                this.filterShow = false;
            },
            // 确认到货
            handleConfirmGoods(item) {
                let params = {
                    params: item.trackingNumber
                }
                this.$axios.post('tracking/sign/confirmGoods', params).then(res => {
                    if (res.data.code === 200) {
                        this.pageNum[this.index] = 1;
                        this.getList(true);
                    }
                })
            }
        },
        mounted() {
        }
    }
</script>


<style lang="scss" scoped>
    .my_wayBill {
        height: 100%;

        .my_wayBill_box {
            overflow: hidden;
            height: 100%;
        }

        &-top {
            background-color: #fff;
            margin-bottom: 0.03rem;
            height: 1.33rem;
            padding: .1rem .59rem;

            &-search {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                background-color: #F1F1F1;
                padding: 0.21rem 0.39rem 0.21rem 0.39rem;
                color: #8F8F8F;
                border-radius: 5px;
                height: 0.59rem;
            }

            &-search img {
                width: 0.53rem;
                height: 0.53rem;
            }
        }

        .total {
            /*background-color: #fff;*/
            height: 1.5rem;
            position: fixed;
            bottom: 0;
            width: 100%;
            padding: 0 0.27rem;
            box-sizing: border-box;

            .total-text {
                font-size: 0.4rem;
                color: #2E2E2E;
                height: 1.07rem;
                line-height: 1.07rem;
                padding-left: 0.32rem;
                border-bottom: 1px solid #E5E5E5;
            }

            .total-row {
                border-top: 1px solid #E5E5E5;
                padding: 0.19rem 0.32rem;
                font-size: 0.37rem;
                color: #4F4F4F;
                background: #fff;
            }
        }
    }

    .van-tab {
        font-size: 0.48rem;
    }

    .van-tab__pane {
        height: 100%;
        padding-top: 0.08rem;
    }

    .van-tabs__content {
        height: 100%;
    }

    .van-tabs__line {
        background-color: #FE9329;
    }

    .van-pull-refresh__track {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .van-list {
        position: relative;
        /*flex: 1;*/
        padding: 0 0.27rem;
    }

    .no-list {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.4rem;
        color: #8F8F8F;
    }

    .van-tabs__wrap {
        z-index: 8;
    }


</style>
